import { extendObservable, runInAction } from 'mobx';

import { CreditController } from '../networking/controllers/CreditController';
import { Logger } from '../helpers/Logger';

class CreditAndPaymentStoreClass {
  constructor() {
    extendObservable(this, {
      credits: null,
      payments: null,
      loadingCredit: false,
      getError: false,
    });
  }

  async getCredits() {
    runInAction(() => {
      this.loadingCredit = true;
    });
    try {
      const data = await CreditController.all();
      runInAction(() => {
        this.credits = data.credits;
        this.payments = data.payments;
      });
    } catch (error) {
      Logger.warn(error);
      runInAction(() => {
        this.getError = true;
      });
    } finally {
      runInAction(() => {
        this.loadingCredit = false;
      });
    }
  }
}

const CreditAndPaymentStore = new CreditAndPaymentStoreClass();

export { CreditAndPaymentStore };



// WEBPACK FOOTER //
// ./src/stores/CreditAndPaymentStore.js